import { StyleShadowRoot } from "@redotech/react-util/style";
import { HsaCartWidgetPlacement } from "@redotech/redo-conversion-core-common/conversion/hsa-autocheck";
import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { memo } from "react";
import { StorefrontClient } from "../../client/storefront";
import STYLE_MANAGER from "../../style-manager";
import { HsaCartWidget } from "./hsa-cart-widget";
import { useHsaCartEligibility } from "./use-hsa-cart-eligibility";
import { useHsaCartPortals } from "./use-hsa-cart-portals";

export const HsaCartInitializer = memo(function HsaCartInitializer({
  placements,
  storefrontClient,
}: {
  placements: HsaCartWidgetPlacement[];
  storefrontClient: StorefrontClient;
}) {
  const summary = useHsaCartEligibility({ storefrontClient });
  const portals = useHsaCartPortals({ placements });

  // Hidden until eligibility is known; nothing renders for a cart with no
  // eligible items.
  if (
    portals.length === 0 ||
    summary === undefined ||
    summary.eligibleLineCount === 0
  ) {
    return null;
  }

  return (
    <>
      {portals.map(({ portal }, index) => (
        <StyleShadowRoot
          key={index}
          shadowRoot={portal.root}
          styleManager={STYLE_MANAGER}
        >
          <ModalRootContext.Provider value={portal.modalContainer}>
            <HsaCartWidget summary={summary} />
          </ModalRootContext.Provider>
        </StyleShadowRoot>
      ))}
    </>
  );
});
